import { FrameworkTemplateViewModel } from "./FrameworkTemplates.types.ts";
import { FrameworkTemplatesProps } from "./FrameworkTemplates.tsx";
import { useState } from "react";
import { isNullOrWhitespace } from "../../common/stringOperations.ts";

import { useDotLegalQuery } from "@common/hooks/dotLegalReactQuery";

export function getFrameworkTemplateUrl(keepUsedTemplates: boolean) {
    return `/frameworks/templates/selectable?keepUsedTemplates=${keepUsedTemplates}`;
}

export function useFetchFrameworkTemplates(keepUsedTemplates: boolean, hideCustomCard?: boolean) {
    const url = getFrameworkTemplateUrl(keepUsedTemplates);
    const { isLoading, data } = useDotLegalQuery<Array<FrameworkTemplateViewModel>>(url, {
        staleTime: 1000,
    });

    let templatesToReturn = data ?? [];
    if (hideCustomCard) {
        templatesToReturn = templatesToReturn.filter((x) => !x.isCustom);
    }

    return {
        isLoading,
        templates: templatesToReturn,
    };
}

export function useFrameworkTemplates(props: FrameworkTemplatesProps) {
    const [searchValue, setSearchValue] = useState("");

    let { isLoading, templates } = useFetchFrameworkTemplates(props.keepUsedTemplates ?? false, props.hideCustomCard);

    if (!isNullOrWhitespace(searchValue)) {
        templates = templates.filter((x) => x.name.toLowerCase().includes(searchValue.toLowerCase()));
    }

    return {
        isLoading,
        templates,
        searchValue,
        setSearchValue,
    };
}
